import * as React from "react";
import "./reconciliationModal.scss"

interface IProps {
	billSummary?: boolean
}

export const SelectedSummaryInfo: React.SFC<IProps> = (props) => {
	const matchedObjectType = props.billSummary ? "bill" : "invoice";
	return (
		<>
			<img className="c-reconciliation-modal_details-icon" src="/assets/img/icons/icn-success-cmn.svg"/>
			<div className="c-reconciliation-modal_details-title">Matched {matchedObjectType}</div>
			{props.children}
		</>
	);
};
